import React from 'react'

const CalendarIcon = props => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.04199 6.67676C1.04199 4.95087 2.4411 3.55176 4.16699 3.55176H15.8337C17.5595 3.55176 18.9587 4.95087 18.9587 6.67676V15.833C18.9587 17.5589 17.5595 18.958 15.8337 18.958H4.16699C2.4411 18.958 1.04199 17.5589 1.04199 15.833V6.67676ZM4.16699 4.80176C3.13146 4.80176 2.29199 5.64122 2.29199 6.67676V15.833C2.29199 16.8685 3.13146 17.708 4.16699 17.708H15.8337C16.8692 17.708 17.7087 16.8685 17.7087 15.833V6.67676C17.7087 5.64122 16.8692 4.80176 15.8337 4.80176H4.16699Z"
        fill="#14142B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83301 1.0408C6.17819 1.04068 6.4581 1.32041 6.45822 1.66559L6.45908 4.17621C6.4592 4.52139 6.17947 4.8013 5.83429 4.80142C5.48911 4.80154 5.2092 4.52181 5.20908 4.17663L5.20822 1.66602C5.2081 1.32084 5.48783 1.04092 5.83301 1.0408Z"
        fill="#14142B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.167 1.04102C14.5122 1.04102 14.792 1.32084 14.792 1.66602V3.859C14.792 4.20418 14.5122 4.484 14.167 4.484C13.8218 4.484 13.542 4.20418 13.542 3.859V1.66602C13.542 1.32084 13.8218 1.04102 14.167 1.04102Z"
        fill="#14142B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.375 7.80664C4.375 7.46146 4.65482 7.18164 5 7.18164L15 7.18164C15.3452 7.18164 15.625 7.46146 15.625 7.80664C15.625 8.15182 15.3452 8.43164 15 8.43164L5 8.43164C4.65482 8.43164 4.375 8.15182 4.375 7.80664Z"
        fill="#14142B"
      />
    </svg>
  )
}

export default CalendarIcon
